// routes/MarketsRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import MarketsPage from '../components/Frontend/MarketsPage/MarketsPage';

export const marketsRoutes = (
    <Route path="/markets" element={<MainLayout />}>
        <Route index element={<MarketsPage />} />
    </Route>
);
